import { createContext } from 'react'
import { useInstantSearch } from 'react-instantsearch'

import type {
  TaggingContextType,
  TaggingProviderProps,
} from './TaggingProvider.types'
import { useTaggingTable } from './useTaggingTable'

export const TaggingContext = createContext<TaggingContextType | null>(null)

export const TaggingProvider = (props: TaggingProviderProps) => {
  const { children, hits } = props
  const { refresh } = useInstantSearch()
  const hook = useTaggingTable({
    hits,
    refresh,
  })

  return (
    <TaggingContext.Provider value={hook}>{children}</TaggingContext.Provider>
  )
}
